import React, { useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const MediaWrap = styled.div`
  width:1740px;
  display: flex; /* 横並び */
  flex-wrap: wrap;
  margin: 4px;
  box-shadow: 0 0 3px 2px 'rgba(0,0,0,0.4)';
  background-color: #649CDF;
  color: #fff;
  font-size: 14px;
  font-weight: bold;

  text-align: center;
  align-items: center;
`
const MediaItem = styled.div`
  display: flex; /* 縦並び */
  flex-direction: column;
  height: 60px;
  border-right: 2px dashed #fff;
`
const MediaRow = styled.div`
  display: flex; /* 縦並び */
  flex-direction: row;
  height: 30px;
`

const HealthTitle = styled.div`
  margin: auto;
  text-overflow: ellipsis; /* 見切れ対策 */
  overflow: hidden;
  white-space: nowrap;
` 

const ProcessHeader = (props) => {
  const {
    targetYMD,targetYM
  } = props

  // 初期値
  useEffect(() => {
  })

  return (
    <MediaWrap>
      <MediaItem>
        <HealthTitle style={{width:'185px'}}>工程</HealthTitle>
      </MediaItem>
      <MediaItem>
        <MediaRow>
          <HealthTitle style={{width:'160pX'}}>{targetYMD}</HealthTitle>
        </MediaRow>
        <MediaRow>
          <HealthTitle style={{width:'80px'}}>稼働人数<br/>(前日比)</HealthTitle>
          <HealthTitle style={{width:'80px'}}>稼働時間<br/>(前日比)</HealthTitle>
        </MediaRow>
      </MediaItem>
      <MediaItem>
        <MediaRow>
          <HealthTitle style={{width:'240pX'}}>{targetYM}</HealthTitle>
        </MediaRow>
        <MediaRow>
          <HealthTitle style={{width:'80px'}}>稼働人数<br/>(前月比)</HealthTitle>
          <HealthTitle style={{width:'80px'}}>稼働時間<br/>(前月比)</HealthTitle>
          <HealthTitle style={{width:'80px'}}>平均時給</HealthTitle>
        </MediaRow>
      </MediaItem>
      <MediaItem>
        <MediaRow>
          <HealthTitle style={{width:'160pX'}}>SUN集計</HealthTitle>
        </MediaRow>
        <MediaRow>
          <HealthTitle style={{width:'80px'}}>稼働人数<br/>(前月比)</HealthTitle>
          <HealthTitle style={{width:'80px'}}>稼働時間<br/>(前月比)</HealthTitle>
        </MediaRow>
      </MediaItem>
      <MediaItem>
        <MediaRow>
          <HealthTitle style={{width:'160pX'}}>MON集計</HealthTitle>
        </MediaRow>
        <MediaRow>
          <HealthTitle style={{width:'80px'}}>稼働人数<br/>(前月比)</HealthTitle>
          <HealthTitle style={{width:'80px'}}>稼働時間<br/>(前月比)</HealthTitle>
        </MediaRow>
      </MediaItem>
      <MediaItem>
        <MediaRow>
          <HealthTitle style={{width:'160pX'}}>TUE集計</HealthTitle>
        </MediaRow>
        <MediaRow>
          <HealthTitle style={{width:'80px'}}>稼働人数<br/>(前月比)</HealthTitle>
          <HealthTitle style={{width:'80px'}}>稼働時間<br/>(前月比)</HealthTitle>
        </MediaRow>
      </MediaItem>
      <MediaItem>
        <MediaRow>
          <HealthTitle style={{width:'160pX'}}>WED集計</HealthTitle>
        </MediaRow>
        <MediaRow>
          <HealthTitle style={{width:'80px'}}>稼働人数<br/>(前月比)</HealthTitle>
          <HealthTitle style={{width:'80px'}}>稼働時間<br/>(前月比)</HealthTitle>
        </MediaRow>
      </MediaItem>
      <MediaItem>
        <MediaRow>
          <HealthTitle style={{width:'160pX'}}>THU集計</HealthTitle>
        </MediaRow>
        <MediaRow>
          <HealthTitle style={{width:'80px'}}>稼働人数<br/>(前月比)</HealthTitle>
          <HealthTitle style={{width:'80px'}}>稼働時間<br/>(前月比)</HealthTitle>
        </MediaRow>
      </MediaItem>
      <MediaItem>
        <MediaRow>
          <HealthTitle style={{width:'160pX'}}>FRI集計</HealthTitle>
        </MediaRow>
        <MediaRow>
          <HealthTitle style={{width:'80px'}}>稼働人数<br/>(前月比)</HealthTitle>
          <HealthTitle style={{width:'80px'}}>稼働時間<br/>(前月比)</HealthTitle>
        </MediaRow>
      </MediaItem>
      <MediaItem>
        <MediaRow>
          <HealthTitle style={{width:'160pX'}}>SAT集計</HealthTitle>
        </MediaRow>
        <MediaRow>
          <HealthTitle style={{width:'80px'}}>稼働人数<br/>(前月比)</HealthTitle>
          <HealthTitle style={{width:'80px'}}>稼働時間<br/>(前月比)</HealthTitle>
        </MediaRow>
      </MediaItem>
    </MediaWrap>
  )
}

ProcessHeader.propTypes = {
  targetYM: PropTypes.string, // 集計月
  targetYMD: PropTypes.string, // 集計日
}

export default ProcessHeader